import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { NotLoggedInGuard } from "../guards/not-logged-in.guard";
import { LoginComponent } from "./login/login.component";
import { PasswordResetComponent } from "./password-reset/password-reset.component";
import { PlaceComponent } from "./place/place.component";

const routes: Routes = [
  { path: "", component: LoginComponent, canActivate: [NotLoggedInGuard] },
  { path: "passwordReset", component: PasswordResetComponent, canActivate: [NotLoggedInGuard] },
  { path: "place/:uid/:FK_Place", component: PlaceComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
